export default {
      id: "logo-usage",
      viewBox: "0 0 373.4 549.6",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#logo",
      toString: function () {
        return this.url;
      }
    }